var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"col bg-faded py-3 p-5 m-5"},[_c('app-edit',{attrs:{"table":_vm.table,"field":_vm.field,"tableInfo":_vm.tableInfo,"nametable":_vm.nametable,"showForm":_vm.showForm}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75298058","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Bread.vue
// module id = mBOT
// module chunks = 6